import { cn } from "@/lib/utils/global-utils";
import React, { forwardRef } from "react";

interface CheckmarkIconProps extends React.SVGProps<SVGSVGElement> {}

const CheckmarkIcon = forwardRef<SVGSVGElement, CheckmarkIconProps>(
  ({ className, ...rest }, ref) => (
    <svg
    ref={ref}
    className={cn('', className)}
    {...rest}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectángulo_49"
            data-name="Rectángulo 49"
            width="20"
            height="20"
            transform="translate(707 443)"
            fill="none"
            stroke="#fff"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g
        id="checkmark-icon"
        transform="translate(-707 -443)"
        clipPath="url(#clip-path)"
      >
        <g
          id="Grupo_40"
          data-name="Grupo 40"
          transform="translate(713.458 450.292)"
        >
          <path
            id="Trazado_8"
            data-name="Trazado 8"
            d="M7.75,12.083l1.875,2.083L14.833,8.75"
            transform="translate(-7.75 -8.75)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.32"
          />
        </g>
      </g>
    </svg>
  )
);

CheckmarkIcon.displayName = "Checkmark Icon";

export default CheckmarkIcon;
